import { render, staticRenderFns } from "./globalStrategy.vue?vue&type=template&id=38ebac49&scoped=true&"
import script from "./globalStrategy.vue?vue&type=script&lang=js&"
export * from "./globalStrategy.vue?vue&type=script&lang=js&"
import style0 from "./globalStrategy.vue?vue&type=style&index=0&id=38ebac49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ebac49",
  null
  
)

export default component.exports